import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const rocheSearchListContainerCss = "roche-search-list-container{display:block;padding-bottom:3rem}@media (min-width: 48rem){roche-search-list-container{padding-bottom:4.5rem}}roche-search-list-container roche-search-input,roche-search-list-container roche-tab-nav-container,roche-search-list-container roche-empty-state,roche-search-list-container .results{margin-bottom:3rem}@media (min-width: 48rem){roche-search-list-container roche-search-input,roche-search-list-container roche-tab-nav-container,roche-search-list-container roche-empty-state,roche-search-list-container .results{margin-bottom:4.5rem}}";
const RocheSearchListContainerStyle0 = rocheSearchListContainerCss;

const RocheSearchListContainer$1 = /*@__PURE__*/ proxyCustomElement(class RocheSearchListContainer extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("slot", { key: '1e5e9a328d42639c7a93685fb2e299d66b2d2420' }));
    }
    static get style() { return RocheSearchListContainerStyle0; }
}, [4, "roche-search-list-container"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-search-list-container"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-search-list-container":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheSearchListContainer$1);
            }
            break;
    } });
}

const RocheSearchListContainer = RocheSearchListContainer$1;
const defineCustomElement = defineCustomElement$1;

export { RocheSearchListContainer, defineCustomElement };

//# sourceMappingURL=roche-search-list-container.js.map